import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import BackButton from '../../components/common/BackButton';

import { FaUser, FaFileAlt, FaCalendarAlt, FaFileUpload, FaCloudUploadAlt, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const ManageReports = () => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [personalNumber, setPersonalNumber] = useState('');
  const [analysisDate, setAnalysisDate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;

    setIsSubmitting(true);
    setMessage(null);

    const formData = new FormData();
    formData.append('file', file);
    if (title) formData.append('title', title);
    if (personalNumber) formData.append('personalNumber', personalNumber);
    if (analysisDate) formData.append('analysisDate', analysisDate);

    try {
      await axios.post('https://hasanhaji.com/api/reports/admin', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setFile(null);
      setTitle('');
      setPersonalNumber('');
      setAnalysisDate('');

      const fileInput = document.getElementById('fileInput');
      if (fileInput) fileInput.value = '';
      setMessage({ type: 'success', text: t('admin.uploadSuccess') });
    } catch (err) {
      console.error(err);
      setMessage({ type: 'error', text: t('admin.uploadError') });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <BackButton to="/admin" />

          <div className="card border-0 rounded-4 overflow-hidden">
            <div
              className="card-header text-white text-center py-4"
              style={{ background: 'linear-gradient(135deg, var(--primary-color) 0%, #6a1b9a 100%)' }}
            >
              <h3 className="mb-0 fw-bold d-flex align-items-center justify-content-center gap-2">
                <FaFileUpload />
                <span>{t('admin.addNewReport')}</span>
              </h3>
              <p className="mb-0 opacity-75 mt-2">{t('admin.uploadReportDescription')}</p>
            </div>

            <div className="card-body p-4 p-md-5 bg-white">
              {message && (
                <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'} d-flex align-items-center mb-4 rounded-3`} role="alert">
                  {message.type === 'success' ? <FaCheckCircle className="me-2 fs-5" /> : <FaExclamationTriangle className="me-2 fs-5" />}
                  <div>{message.text}</div>
                </div>
              )}

              <form onSubmit={handleUpload}>
                <div className="row g-4">
                  { }
                  <div className="col-md-6">
                    <label className="form-label fw-bold text-muted small">{t('admin.personalNumber')}</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-end-0"><FaUser className="text-secondary" /></span>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0 bg-light"
                        placeholder={t('admin.enterPersonalNumber')}
                        value={personalNumber}
                        onChange={(e) => setPersonalNumber(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  { }
                  <div className="col-md-6">
                    <label className="form-label fw-bold text-muted small">{t('admin.reportTitle')}</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-end-0"><FaFileAlt className="text-secondary" /></span>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0 bg-light"
                        placeholder={t('admin.reportTitlePlaceholder')}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>

                  { }
                  <div className="col-md-12">
                    <label className="form-label fw-bold text-muted small">{t('admin.analysisDate')}</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-end-0"><FaCalendarAlt className="text-secondary" /></span>
                      <input
                        type="date"
                        className="form-control border-start-0 ps-0 bg-light"
                        value={analysisDate}
                        onChange={(e) => setAnalysisDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  { }
                  <div className="col-12">
                    <label className="form-label fw-bold text-muted small">{t('admin.reportFile')}</label>
                    <div className="file-upload-wrapper p-4 border rounded-3 text-center position-relative" style={{ borderStyle: 'dashed !important', borderColor: 'var(--primary-color)', backgroundColor: '#fdfbff' }}>
                      <input
                        type="file"
                        id="fileInput"
                        className="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0"
                        accept="application/pdf"
                        onChange={handleFileChange}
                        style={{ cursor: 'pointer' }}
                        required
                      />
                      <div className="d-flex flex-column align-items-center justify-content-center text-muted pointer-events-none">
                        <FaCloudUploadAlt className="fs-1 mb-2" style={{ color: 'var(--primary-color)' }} />
                        <span className="fw-bold text-dark">{file ? file.name : t('admin.dragDropFile')}</span>
                        {!file && <small className="text-muted mt-1">{t('admin.fileMustBePdf')}</small>}
                      </div>
                    </div>
                  </div>

                  { }
                  <div className="col-12 mt-4">
                    <button
                      type="submit"
                      className="btn w-100 py-3 text-white fw-bold"
                      style={{
                        background: isSubmitting ? '#6c757d' : 'var(--primary-color)',
                        transition: 'all 0.3s ease',
                        transform: isSubmitting ? 'none' : 'translateY(0)',
                      }}
                      disabled={isSubmitting}
                      onMouseOver={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(-2px)')}
                      onMouseOut={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(0)')}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          {t('admin.uploading')}
                        </>
                      ) : (
                        t('admin.uploadStart')
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageReports;
